module.exports = __webpack_public_path__ + "images/715995078fc7f83ca75e0b1d38ed10d9.jpg";